'use client';

import { Link } from '@coolblue-development/freddy';
import clickReviewsTrigger from '@coolblue-development/ga4-events/triggers/OutOfStockEntrance/clickReviewsTrigger';
import selectAlternativeTrigger from '@coolblue-development/ga4-events/triggers/OutOfStockEntrance/selectAlternativeTrigger';
import { useAnalytics } from '@coolblue-development/next-analytics/client';
import { ProductTitle } from '@coolblue-development/next-patterns/client';
import type { Product } from '@features/product/typings';

export const AlternativeProductTitle = ({
  product,
  index,
  totalIndices
}: {
  product: Product;
  index: number;
  totalIndices: number;
}) => {
  const { trackEvent } = useAnalytics();

  const handleTitleClick = () => {
    trackEvent(
      selectAlternativeTrigger({
        index: index + 1,
        total_indices: totalIndices,
        method: 'title',
        item_id: product.id
      })
    );
  };

  const handleReviewClick = () => {
    trackEvent(
      clickReviewsTrigger({
        item_id: product.id
      })
    );
  };

  return (
    <ProductTitle>
      <ProductTitle.Title size='medium'>
        {product.urls ? (
          <Link href={product.urls.product} onClick={handleTitleClick}>
            {product.name}
          </Link>
        ) : (
          product.name
        )}
      </ProductTitle.Title>
      {product.reviewMetaData && product.urls && (
        <ProductTitle.Review
          size={{ xs: 'small', md: 'medium' }}
          value={product.reviewMetaData.averageRating}
          reviewCount={product.reviewMetaData.count}
          href={`${product.urls.product}#product-reviews`}
          showScore={false}
          onClick={handleReviewClick}
        />
      )}
    </ProductTitle>
  );
};
